module.exports = __webpack_public_path__ + "img/img32.4a721167.svg";